import React from 'react';
import moment from 'moment';
import { Item, List, Label } from 'semantic-ui-react';

const ClaimInformation = ({
  crmState,
  createdAt,
  updatedAt,
  reason,
  reasonForAbandon,
  totalDelay,
  magicKey,
  travelerFormUrl,
  testimonialUrl,
  paymentUrl,
  passengerTicket
}) => (
  <Item>
    <Item.Content>
      <Item.Header>Claim Information</Item.Header>
      <Item.Description>
        <List>
          <List.Item>
            <List.Content>
              Status:&nbsp;
              <Label color="blue" horizontal>
                {crmState}
              </Label>
            </List.Content>
          </List.Item>
          {reasonForAbandon && (
            <List.Item>
              <List.Content>Reason for abandon: {reasonForAbandon}</List.Content>
            </List.Item>
          )}
          <List.Item>
            <List.Content>
              Created At: {moment(createdAt).format('DD/MM/YYYY')}
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Content>
              Updated At: {moment(updatedAt).format('DD/MM/YYYY')}
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Content>Type of disturbance: {reason}</List.Content>
          </List.Item>
          <List.Item>
            <List.Content>Total delay: {totalDelay}</List.Content>
          </List.Item>
          <List.Item>
            <List.Content>Magic key: {magicKey}</List.Content>
          </List.Item>
          <List.Item>
            <List.Content>
              Traveler form link:{' '}
              <a href={travelerFormUrl} target="_blank">
                {travelerFormUrl}
              </a>
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Content>
              Payment link:{' '}
              <a href={paymentUrl} target="_blank">
                {paymentUrl}
              </a>
            </List.Content>
            </List.Item>
            <List.Item>
            <List.Content>
              Traveler testimonial link:{' '}
              {passengerTicket.passengerLanguage !== "French"
                ? <a href={testimonialUrl} target="_blank">
                  {testimonialUrl}
                </a>
                : "sent to Trustpilot"
}
            </List.Content>
          </List.Item>
        </List>
      </Item.Description>
    </Item.Content>
  </Item>
);

export default ClaimInformation;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/ClaimInformation.js